import React from "react";
import GTMTemplateCard from "./gtm-template-card";
import "../styles/components/gtm-templates.css";

const templates = [
  {
    icon: "📊",
    title: "Enkel GA4 SST",
    tags: ["GA4"],
    description: "Ferdig mal til en enkel GA4 SST (Server Side Tagging)",
    downloadLink: "#",
  },
  {
    icon: "⛓️‍💥",
    title: "Meta Conversion API",
    tags: ["Facebook", "Instagram"],
    description: "Ferdig mal til Meta sin Conversion API",
    downloadLink: "#",
  },
  {
    icon: "🍪",
    title: "Fjell Digital CMP",
    tags: ["GDPR", "Personvern"],
    description:
      "Consent Management Platform fra Fjell Digital. Ferdig integrasjon med GTM og SST",
    downloadLink: "#",
  },
  {
    icon: "🛒",
    title: "GA4 Enhanced Ecommerce",
    tags: ["GA4", "Ecommerce"],
    description: "Ferdig mal til Enhanced Ecommerce for GA4",
    downloadLink: "#",
  },
];

const GTMTemplateLibrary = () => {
  return (
    <div>
      <h2>GTM Maler:</h2>
      <div className="gtm-template-library">
        {templates.map((template, index) => (
          <GTMTemplateCard
            key={index}
            icon={template.icon}
            title={template.title}
            tags={template.tags}
            description={template.description}
            downloadLink={template.downloadLink}
          />
        ))}
      </div>
    </div>
  );
};

export default GTMTemplateLibrary;
